module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/invoice-customer-check/invoice-customer-check.component.scss
// module id = ./src/app/modules/boxoffice-module/components/invoice-customer-check/invoice-customer-check.component.scss
// module chunks = 9